module.exports = __webpack_public_path__ + "assets/img/27_1282_big.81f1e2c0.jpg";